import React, {useEffect, useRef, useState} from "react";
import {Button, Form, Popover, Space, Row, Table, Popconfirm} from "antd";
import "./ListPatientNurse.scss";
import dataField, {allColumns} from "./config";
import {CalendarSVG, CalendarSelectedSVG, ExcelSVG, ListIconSVG} from "assets";
import {ColumnProps} from "types/models";
import {catalogService} from "api";
import {nurseOutService} from "api";
import {
  formatDateToString,
  getTableOptions,
  saveTableOptions,
} from "helper/common";
import {
  ListActionButton,
  ExpandSearch,
  ColumnPopoverDisplay,
  DilateStatusCard,
  ButtonExcel,
} from "components/common";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {
  getListPhongAPI,
  setActiveKey,
  setIdPhieuKham,
} from "redux/reducer/common";
import {tabKeys} from "types/enums";
import {
  setCallApiList,
  setIdPhieu,
  setIdReceiptNurseOut,
  setlistThuocTraMat,
} from "redux/reducer/nurseOut";
import Notification from "components/common/notification/notification";
import {ReactComponent as RecycleIconSVG} from "assets/images/svg/recycle.svg";
import ModalCustom from "components/common/ModalCustom/ModalCustom";
import ModalContent from "./ModalContent/ModalContent";
import moment from "moment";
import dayjs from "dayjs";
import NurseOutModal from "components/common/PrintReceipt/NurseOutModal/NurseOutModal";
import KCBTypeColumn from "components/common/ColumnColors/KCBTypeColumn/KCBTypeColumn";
import CustomResizableTable from "components/common/CustomResizableTable/CustomResizableTable";
import CheckNullApi from "components/common/CheckNullApi/CheckNullApi";
const ListPatientNurse: React.FC = () => {
  let savedTableOption = getTableOptions(
    "NURSE_OUT_TABLE",
    localStorage.getItem("username")
  );
  const defaultColumns = savedTableOption
    ? allColumns.map(cl => {
        if (savedTableOption.some(it => it.dataIndex === cl.dataIndex)) {
          let tmp = savedTableOption.find(it => it.dataIndex === cl.dataIndex);
          return {
            ...cl,
            show: true,
            width: tmp?.width ?? null,
          };
        } else
          return {
            ...cl,
            show: false,
          };
      })
    : allColumns;
  const dispatch = useAppDispatch();
  const activeTab = useAppSelector(state => state.common.activeTab);
  const callApiList = useAppSelector(state => state.nurseOut.callApiList);
  const expandRef = useRef<any>();
  const modalRef = useRef<any>();
  const printRef = useRef<any>();
  const [params, setParams] = useState<any>({
    page: 1,
    limit: 50,
    ngayTaoTu: moment().format(),
    ngayTaoDen: moment().format(),
  });

  const listPhong = useAppSelector(state => state.common.listPhong);
  const [columns, setColumns] = useState<ColumnProps[]>(
    defaultColumns.filter(e => e.show == true)
  );
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any>();
  const [total, setTotal] = useState();
  const [selectedBtn, setSelectedBtn] = useState<number | null>(1);

  useEffect(() => {
    if (callApiList && activeTab == tabKeys.NURSE_OUT.LIST_PATIENT) {
      getList();
    }
  }, [callApiList, activeTab]);
  useEffect(() => {
    // setOptionsPhong(listPhong);
  }, [listPhong]);
  useEffect(() => {
    getListDilate();
    dispatch(getListPhongAPI());
    onToday(1);
  }, []);

  useEffect(() => {
    getList();
  }, [params]);

  const renderLoaiKCB = listKCB => {
    columns.find(e => e.dataIndex == "loaiKCB").render = (v, r, i) => {
      let textKCB = listKCB.find(e => e.id == v)?.tenLoaiKCB;
      return <KCBTypeColumn label={textKCB}></KCBTypeColumn>;
    };
  };
  const handleDelete = async id => {
    const newData = await data?.filter(item => item.id !== id);

    setData(newData);
  };
  const handlePrint = id => {
    dispatch(setIdReceiptNurseOut(id));
    printRef.current?.openModal();
  };

  const handleEdit = id => {
    dispatch(setActiveKey(tabKeys.NURSE_OUT.DETAIL_PATIENT));
    dispatch(setIdPhieu(id));
  };
  const postStatusNurseForm = async (id, trangThai) => {
    setLoading(true);
    try {
      const params = {
        id: id,
        trangThai: trangThai,
      };
      const res = await nurseOutService.postStatusNurseForm(params);
      // setDetailPhieu(res);

      setLoading(false);
      let message = "";
      if (trangThai == 1) {
        message = "Đã cập nhật phiếu thành trạng thái Chờ thực hiện";
      }
      if (trangThai == 3) {
        message = "Đã cập nhật phiếu thành trạng thái Hoàn thành";
      }
      if (trangThai == 6) {
        message = "Đã cập nhật phiếu thành trạng thái Hủy thực hiện";
      }
      if (trangThai == 7) {
        message = "Đã xóa thông tin phiếu";
      }

      getList();

      Notification("success", message);
    } catch (error) {
      setLoading(false);

      Notification("error", "Đã có lỗi xảy ra");
    }
  };
  columns.find(e => e.dataIndex == "action").render = (
    value,
    _record,
    index
  ) => {
    return (
      <ListActionButton
        editFunction={() => handleEdit(_record.id)}
        printFunction={() => handlePrint(_record.id)}
      >
        <Popconfirm
          className="danger-confirm"
          title={`Đồng ý ${
            _record["trangThai"] == 3 ? "xóa thông tin" : "hủy khám"
          }`}
          onConfirm={() => {
            if (_record?.trangThai == 3) {
              handleDelete(_record.id);
              postStatusNurseForm(_record.id, 7);
            } else {
              postStatusNurseForm(_record.id, 6);
            }
          }}
        >
          <Button icon={<RecycleIconSVG />} />
        </Popconfirm>
      </ListActionButton>
    );
  };
  columns.find(e => e.dataIndex == "traThuoc").render = (
    value,
    record,
    index
  ) => {
    return (
      <div
        onClick={() => {
          // if (record?.traThuoc != 0) {
          dispatch(setIdPhieu(record?.id));
          modalRef.current?.openModal();
          // }
        }}
      >
        {record && (
          <DilateStatusCard
            name={record?.tenThuoc}
            status={record.traThuoc}
            timeDilate={record.thoiGianTraThuoc}
          ></DilateStatusCard>
        )}
      </div>
    );
  };

  const onToday = (key: number) => {
    setLoading(true);
    let today = dayjs();
    expandRef.current?.setFieldValue("ngayTaoTu", today);
    expandRef.current?.setFieldValue("ngayTaoDen", today);
    setParams({...params, ...expandRef.current?.getData()});
    setSelectedBtn(key);
  };

  const onYesterday = (key: number) => {
    setLoading(true);
    let yesterday = dayjs().subtract(1, "day");
    expandRef.current?.setFieldValue("ngayTaoTu", yesterday);
    expandRef.current?.setFieldValue("ngayTaoDen", yesterday);
    setParams({
      ...params,
      ...expandRef.current?.getData(),
    });

    setSelectedBtn(key);
  };
  const onChangePagination = (page, pageSize) => {
    setParams({...params, page: page, limit: pageSize});
  };

  const setShowColumns = showColumns => {
    saveTableOptions(
      "NURSE_OUT_TABLE",
      localStorage.getItem("username"),
      showColumns
    );
    setColumns(showColumns);
  };

  const onClickSearchButton = () => {
    var searchFields = expandRef.current?.getData();
    setParams({...params, ...searchFields, page: 1});
  };
  // const setOptionsPhong = listPhong => {
  //   const dataFields = dataField();
  //   dataFields.find(e => e.name == "phong").options = listPhong
  //     // .filter(
  //     //   e =>
  //     //     e.tenPhong == "Phòng điều dưỡng" ||
  //     //     e.tenPhong == "Phòng điều dưỡng  (Tầng 2)"
  //     // )
  //     .map(e => {
  //       return {value: e.id, label: e.tenPhong};
  //     });
  //   // const idPhongDieuDuong =
  //   //   listPhong?.find(e => e.tenPhong == "Phòng điều dưỡng")?.id || null;
  //   // expandRef.current?.setFieldValue("phong", idPhongDieuDuong);
  //   // setParams({...params, phong: idPhongDieuDuong});
  // };

  const getListDilate = async () => {
    try {
      const res = await nurseOutService.getListDilate();
      dispatch(setlistThuocTraMat(res));
    } catch (error) {
      Notification("error", "Đã xảy ra lỗi khi lấy danh sách thuốc tra mắt");
    }
  };

  const getList = async () => {
    // alert("get list");
    setLoading(true);
    try {
      const res = await nurseOutService.getListNurseOut(formatParams());
      const newData = res.data.map(item => ({...item, key: item.id}));
      setData(newData);
      setTotal(res.total);
      setLoading(false);
      dispatch(setCallApiList(false));
      setColumns([...columns]);
    } catch (error) {
      setLoading(false);
      dispatch(setCallApiList(false));
      Notification("error", "Đã có lỗi xảy ra khi tải dữ liệu");
    }
  };

  const formatParams = () => {
    return {
      ...params,
      ngaySinh: formatDateToString(params.ngaySinh),
      ngayTaoTu: formatDateToString(params.ngayTaoTu),
      ngayTaoDen: formatDateToString(params.ngayTaoDen),
    };
  };

  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selections) => {
      dispatch(setIdPhieu(selections[0].id));
      dispatch(setIdPhieuKham(selections[0]?.idPhieuKham));
    },
  };

  const label = [
    {
      key: 1,
      value: "Hôm nay",
      onclick: e => onToday(e),
    },
    {
      key: 2,
      value: "Hôm qua",
      onclick: e => onYesterday(e),
    },
  ];
  const onKeyDown = e => {
    if (e.key === "Enter") {
      onClickSearchButton();
    }
  };
  //check xem có đủ api chưa?
  useEffect(() => {
    CheckNullApi();
  }, []);
  return (
    <div className="list-patient-nurse">
      <div className="container" onKeyDown={onKeyDown} tabIndex={0}>
        <Space direction="vertical" style={{width: "100%"}}>
          <ExpandSearch
            ref={expandRef}
            onClickSearch={onClickSearchButton}
            fields={dataField()}
            onReset={onClickSearchButton}
          ></ExpandSearch>
        </Space>
      </div>

      <div className="container">
        <Space direction="vertical" style={{width: "100%"}}>
          <Row justify={"end"} gutter={[16, 16]}>
            <Space>
              {label.map(item => (
                <Button
                  key={item.key}
                  onClick={() => {
                    item.onclick(item.key);
                  }}
                  className={
                    item.key === selectedBtn ? "btn-sub" : "custom-btn"
                  }
                  icon={
                    item.key === selectedBtn ? (
                      <CalendarSelectedSVG />
                    ) : (
                      <CalendarSVG />
                    )
                  }
                >
                  {item.value}
                </Button>
              ))}

              <Popover
                trigger="click"
                placement="topLeft"
                content={
                  <ColumnPopoverDisplay
                    setShowColumns={setShowColumns}
                    columns={defaultColumns}
                  ></ColumnPopoverDisplay>
                }
              >
                <Button className="btn-sub" icon={<ListIconSVG />}>
                  Cột hiển thị
                </Button>
              </Popover>
              {/* <ButtonExcel></ButtonExcel> */}
            </Space>
            {/* </Col> */}
          </Row>
          <CustomResizableTable
            setShowColumns={setShowColumns}
            loading={loading}
            columns={columns}
            // className="custom-resize-table-scroll"
            dataSource={data}
            pagination={{
              position: ["bottomRight"],
              showSizeChanger: true,
              pageSize: params.limit,
              total: total,
              onChange: onChangePagination,
            }}
            onRow={record => ({
              onDoubleClick: () => handleEdit(record.id),
            })}
            bordered
            rowSelection={{
              type: "radio",
              ...rowSelection,
            }}
            // scroll={{ x: '100%', y: 500 }}
          />
        </Space>
      </div>

      <ModalCustom draggable width={1000} ref={modalRef} title="Tra thuốc">
        <ModalContent dilate={() => {}} getListPhieu={getList}></ModalContent>
      </ModalCustom>
      <ModalCustom ref={printRef} width={1000} centered>
        <NurseOutModal></NurseOutModal>
      </ModalCustom>
    </div>
  );
};
export default ListPatientNurse;
